import { createRoot } from 'react-dom/client'
import { App } from './App'
import { IndexPage } from './IndexPage'
import { isShowKey } from '../shared'

const slug = window.location.pathname.slice(1)
const rootEl = isShowKey(slug) ? <App showKey={slug} /> : <IndexPage />

// biome-ignore lint/style/noNonNullAssertion: It will definitely be there
const root = createRoot(document.getElementById('root')!)
root.render(rootEl)
